import {Component, Inject, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatList, MatListItem, MatListItemIcon} from '@angular/material/list';
import {Asset} from '@app/asset';
import {Stream} from '@app/stream/models';

class AssetStreamData {
    asset: Asset;
    streams: Stream[];
}

@Component({
    selector: 'frog-asset-stream-dialog',
    templateUrl: './asset-stream-dialog.component.html',
    styleUrls: ['./asset-stream-dialog.component.scss'],
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatList,
        MatListItem,
        MatIcon,
        MatListItemIcon,
        MatDialogActions,
        MatButton,
        MatDialogClose,
    ],
})
export class AssetStreamDialogComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: AssetStreamData) {}

    ngOnInit(): void {}
}
